import React from "react";
import HeaderRight from "./HeaderRight";
import HeaderLeft from "./HeaderLeft";
import { Link } from "react-router-dom";

function YouApplicationIsApproved(props) {
  return (
    <>
      <header>
        <div class="custom_container ">
          <HeaderLeft />
          <div class="user_profile">
            <HeaderRight />
          </div>
        </div>
      </header>
      <section class="otp_verification custom_hight">
        <div class="login_inner">
          <h1 class="mb_30 main_title ">Your Application Is Approved</h1>

          <div class="btn_wraper">
          <Link to='/available'>
          <button type="button" class="them_btn mt_40 mb_30">
            Continue
          </button>
          </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default YouApplicationIsApproved;
